import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function Categories() {
  const { t } = useTranslation();

  const getCategoryCount = (slug: string) =>
    articles.filter((a) => a.category === slug).length;

  return (
    <section id="categories" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            {t('home.categoriesTitle')}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            四个维度，全方位解读重组家庭关系
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-6 hover:border-primary-200 hover:bg-background-100 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                {cat.description}
              </p>
              <span className="text-xs text-foreground-500">
                {getCategoryCount(cat.slug)} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}